<h2 mat-dialog-title>{{'messages.errors.userLoading' | translate}}</h2>

<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="onRetryClick()">Riprova</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="onLogoutClick()">Logout</button>
</div>
